import React, { useState } from "react";
import { useQuery } from "react-apollo-hooks";
import { FEE_MANAGER_LIST_QUERY } from "./Queries";
import AsyncSelect from "react-select/async";

const WriteManager = ({ setManager, defaultManager }) => {
  const [keyword, setKeyword] = useState("");
  const { data, loading } = useQuery(FEE_MANAGER_LIST_QUERY, {
    variables: { keyword, first: 20 },
  });

  const loadOptions = (inputValue, callback) => {
    if (!loading && data && data.AdminFeeManagerList) {
      const options = data.AdminFeeManagerList.map((user) => {
        return {
          value: user.id,
          label: `${user.name}(${user.userId})`,
        };
      });

      callback(options);
    } else {
      callback([]);
    }
  };
  const handleInputChange = (value) => {
    setTimeout(() => {
      setKeyword(value);
      return value;
    }, 500);
  };

  return (
    <AsyncSelect
      name="manager"
      placeholder="담당자 이름/아이디 검색"
      noOptionsMessage={() => {
        return "이름 또는 아이디를 검색해주세요.";
      }}
      isClearable
      loadOptions={loadOptions}
      onInputChange={handleInputChange}
      onChange={(option) => {
        setManager(option ? option.value : "");
      }}
      defaultValue={defaultManager}
    />
  );
};

export default WriteManager;
